/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Hub_Recent_RunsInputs */



/**
* | output |
* | --- |
* | "Recent runs" |
*
* @param {Agent_Hub_Recent_RunsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_hub_recent_runs = /** @type {((inputs?: Agent_Hub_Recent_RunsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Hub_Recent_RunsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Letzte Läufe")
	return /** @type {LocalizedString} */ ("Recent runs")
});